module.exports = __webpack_public_path__ + "img/callcontact-logo-2.af1b5141.png";